<template>
  <div class="main-template" :class="[{from_login: from_login}]" v-show="showPageContent">

    <div class="menu" :class="[{hided: hided_menu}, {mobile_show: show_mobile_menu}]">
      <div class="header" :class="[{hided: hided_menu}]">

        <region-selector v-show="!hided_menu"></region-selector>

        <a class="logo" href="/lk/main/"><img :src="logoImg"></a>
        <div class="hide_menu" :class="[{active: hided_menu}]" @click="hideMenu()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M17 7L13 12L17 17" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 7L7 12L11 17" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <menu-compselector :hided_menu="hided_menu" :current-counterparty="current_counterparty" @click="openSelector()"></menu-compselector>

      <div class="navigations">
        <div class="navigation">

          <div class="nav_item"
               v-for="navItem in navItems" :key="navItem"
               :class="[{active: navItem.match_routes.includes(currRoute)}]">
            <div class="top_level_item">
              <svg @click="navigate(navItem.route)" v-if="navItem.name == 'Главная'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M1.5 10.3261C1.5 9.47215 1.5 9.04518 1.60929 8.65144C1.70611 8.30264 1.86525 7.97424 2.07902 7.68212C2.32034 7.35236 2.65546 7.08779 3.32571 6.55865L8.02571 2.84812C9.08828 2.00925 9.61957 1.58981 10.2076 1.42878C10.7263 1.28671 11.2737 1.28671 11.7924 1.42878C12.3804 1.58981 12.9117 2.00925 13.9743 2.84813L18.6743 6.55865C19.3445 7.08779 19.6797 7.35236 19.921 7.68212C20.1348 7.97424 20.2939 8.30264 20.3907 8.65144C20.5 9.04518 20.5 9.47215 20.5 10.3261V15.7C20.5 17.3802 20.5 18.2202 20.173 18.862C19.8854 19.4265 19.4265 19.8854 18.862 20.173C18.2202 20.5 17.3802 20.5 15.7 20.5H15.6C15.0399 20.5 14.7599 20.5 14.546 20.391C14.3578 20.2951 14.2049 20.1422 14.109 19.954C14 19.7401 14 19.4601 14 18.9V16.1C14 15.5399 14 15.2599 13.891 15.046C13.7951 14.8578 13.6422 14.7049 13.454 14.609C13.2401 14.5 12.9601 14.5 12.4 14.5H11H9.6C9.03995 14.5 8.75992 14.5 8.54601 14.609C8.35785 14.7049 8.20487 14.8578 8.10899 15.046C8 15.2599 8 15.5399 8 16.1V18.9C8 19.4601 8 19.7401 7.89101 19.954C7.79513 20.1422 7.64215 20.2951 7.45399 20.391C7.24008 20.5 6.96005 20.5 6.4 20.5H6.3C4.61984 20.5 3.77976 20.5 3.13803 20.173C2.57354 19.8854 2.1146 19.4265 1.82698 18.862C1.5 18.2202 1.5 17.3802 1.5 15.7L1.5 10.3261Z" stroke="#222222" stroke-width="1.5"/>
              </svg>
              <svg @click="navigate(navItem.route)" v-if="navItem.name == 'Каталог'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M1 17C1 15.4596 1 14.6893 1.34673 14.1235C1.54074 13.8069 1.80693 13.5407 2.12353 13.3467C2.68934 13 3.45956 13 5 13C6.54044 13 7.31066 13 7.87647 13.3467C8.19307 13.5407 8.45926 13.8069 8.65327 14.1235C9 14.6893 9 15.4596 9 17C9 18.5404 9 19.3107 8.65327 19.8765C8.45926 20.1931 8.19307 20.4593 7.87647 20.6533C7.31066 21 6.54044 21 5 21C3.45956 21 2.68934 21 2.12353 20.6533C1.80693 20.4593 1.54074 20.1931 1.34673 19.8765C1 19.3107 1 18.5404 1 17Z" stroke="#222222" stroke-width="1.5"/>
                <path d="M13 17C13 15.4596 13 14.6893 13.3467 14.1235C13.5407 13.8069 13.8069 13.5407 14.1235 13.3467C14.6893 13 15.4596 13 17 13C18.5404 13 19.3107 13 19.8765 13.3467C20.1931 13.5407 20.4593 13.8069 20.6533 14.1235C21 14.6893 21 15.4596 21 17C21 18.5404 21 19.3107 20.6533 19.8765C20.4593 20.1931 20.1931 20.4593 19.8765 20.6533C19.3107 21 18.5404 21 17 21C15.4596 21 14.6893 21 14.1235 20.6533C13.8069 20.4593 13.5407 20.1931 13.3467 19.8765C13 19.3107 13 18.5404 13 17Z" stroke="#222222" stroke-width="1.5"/>
                <path d="M1 5C1 3.45956 1 2.68934 1.34673 2.12353C1.54074 1.80693 1.80693 1.54074 2.12353 1.34673C2.68934 1 3.45956 1 5 1C6.54044 1 7.31066 1 7.87647 1.34673C8.19307 1.54074 8.45926 1.80693 8.65327 2.12353C9 2.68934 9 3.45956 9 5C9 6.54044 9 7.31066 8.65327 7.87647C8.45926 8.19307 8.19307 8.45926 7.87647 8.65327C7.31066 9 6.54044 9 5 9C3.45956 9 2.68934 9 2.12353 8.65327C1.80693 8.45926 1.54074 8.19307 1.34673 7.87647C1 7.31066 1 6.54044 1 5Z" stroke="#222222" stroke-width="1.5"/>
                <path d="M13 5C13 3.45956 13 2.68934 13.3467 2.12353C13.5407 1.80693 13.8069 1.54074 14.1235 1.34673C14.6893 1 15.4596 1 17 1C18.5404 1 19.3107 1 19.8765 1.34673C20.1931 1.54074 20.4593 1.80693 20.6533 2.12353C21 2.68934 21 3.45956 21 5C21 6.54044 21 7.31066 20.6533 7.87647C20.4593 8.19307 20.1931 8.45926 19.8765 8.65327C19.3107 9 18.5404 9 17 9C15.4596 9 14.6893 9 14.1235 8.65327C13.8069 8.45926 13.5407 8.19307 13.3467 7.87647C13 7.31066 13 6.54044 13 5Z" stroke="#222222" stroke-width="1.5"/>
              </svg>
              <svg @click="navigate(navItem.route)" v-if="navItem.name == 'Мои заказы'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M1 15C1 12.6611 1 11.4917 1.53647 10.6379C1.81621 10.1927 2.19267 9.81621 2.63789 9.53647C3.49167 9 4.66111 9 7 9H15C17.3389 9 18.5083 9 19.3621 9.53647C19.8073 9.81621 20.1838 10.1927 20.4635 10.6379C21 11.4917 21 12.6611 21 15C21 17.3389 21 18.5083 20.4635 19.3621C20.1838 19.8073 19.8073 20.1838 19.3621 20.4635C18.5083 21 17.3389 21 15 21H7C4.66111 21 3.49167 21 2.63789 20.4635C2.19267 20.1838 1.81621 19.8073 1.53647 19.3621C1 18.5083 1 17.3389 1 15Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 9C19 7.59987 19 6.8998 18.7275 6.36502C18.4878 5.89462 18.1054 5.51217 17.635 5.27248C17.1002 5 16.4001 5 15 5H7C5.59987 5 4.8998 5 4.36502 5.27248C3.89462 5.51217 3.51217 5.89462 3.27248 6.36502C3 6.8998 3 7.59987 3 9" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 5C17 3.11438 17 2.17157 16.4142 1.58579C15.8284 1 14.8856 1 13 1H9C7.11438 1 6.17157 1 5.58579 1.58579C5 2.17157 5 3.11438 5 5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 13C14 14.1046 13.1046 15 12 15H10C8.89543 15 8 14.1046 8 13" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <svg @click="navigate(navItem.route)" v-if="navItem.name == 'Взаиморасчёты'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.0599 19.39C14.4399 19.81 13.6599 20.16 12.7099 20.47L11.1299 20.99C7.15985 22.27 5.06985 21.2 3.77985 17.23L2.49985 13.28C1.21985 9.30998 2.27985 7.20998 6.24985 5.92998L7.82985 5.40998C8.23985 5.27998 8.62985 5.16998 8.99985 5.09998C8.69985 5.70998 8.45985 6.44998 8.25985 7.29998L7.27985 11.49C6.29985 15.67 7.58985 17.73 11.7599 18.72L13.4399 19.12C14.0199 19.26 14.5599 19.35 15.0599 19.39Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.6401 8.53003L17.4901 9.76003" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.6602 12.4L14.5602 13.14" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg @click="navigate(navItem.route)" v-if="navItem.name == 'Избранное'"  xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                <path d="M18.4626 1.99415C15.7809 0.349229 13.4404 1.01211 12.0344 2.06801C11.4578 2.50096 11.1696 2.71743 11 2.71743C10.8304 2.71743 10.5422 2.50096 9.96565 2.06801C8.55962 1.01211 6.21909 0.349229 3.53744 1.99415C0.0180686 4.15294 -0.778279 11.2749 7.33953 17.2834C8.88572 18.4278 9.65881 19 11 19C12.3412 19 13.1143 18.4278 14.6605 17.2834C22.7783 11.2749 21.9819 4.15294 18.4626 1.99415Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <div v-show="!hided_menu">
                <span @click="navigate(navItem.route)">{{navItem.name}}</span>
                <svg class="open_sub_menu"
                     v-show="navItem.subItems.length > 0"
                     :class="[{open: navItem.opened}]"
                     @click="function(){navItem.opened = !navItem.opened}"
                     xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5.83398 8.33334L10.0007 11.6667L14.1673 8.33334" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="sub_level" :class="[{open: navItem.opened}]" v-show="!hided_menu">
              <span
                  v-for="subItem in navItem.subItems" :key="subItem"
                  @click="navigate(subItem.route)"
                  :class="[{active: subItem.match_routes.includes(currRoute)}]"
              >{{subItem.name}}
              </span>
            </div>
          </div>

        </div>



        <div class="navigation bottom">

          <div class="nav_item" @click="toSettings('#legal_settings')">
            <div class="top_level_item">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5.18007 15.2964C3.92249 16.0335 0.625213 17.5386 2.63348 19.422C3.6145 20.342 4.7071 21 6.08077 21H13.9192C15.2929 21 16.3855 20.342 17.3665 19.422C19.3748 17.5386 16.0775 16.0335 14.8199 15.2964C11.8709 13.5679 8.12906 13.5679 5.18007 15.2964Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 7C14 9.20914 12.2091 11 10 11C7.79086 11 6 9.20914 6 7C6 4.79086 7.79086 3 10 3C12.2091 3 14 4.79086 14 7Z" stroke="#222222" stroke-width="1.5"/>
                <path d="M19.5 4V9M22 6.5L17 6.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div v-show="!hided_menu">
                <span>Новый контрагент</span>
              </div>
            </div>
          </div>

          <div class="nav_item" v-show="false">
            <div class="top_level_item">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#222222" stroke-width="1.5"/>
                <path d="M11.9998 16.2105H12.0093" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 13.0526L12 6.73684" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div v-show="!hided_menu">
                <span>Обратная связь</span>
              </div>
            </div>
          </div>

          <div class="nav_item" @click="logout()">
            <div class="top_level_item">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                <path d="M7.75 1L7.00462 1.25983C4.1035 2.27111 2.65294 2.77675 1.82647 3.93046C1 5.08418 1 6.60344 1 9.64196V12.358C1 15.3966 1 16.9158 1.82647 18.0695C2.65294 19.2233 4.1035 19.7289 7.00462 20.7402L7.75 21" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M19 11L7.75 11M19 11C19 10.222 16.7564 8.76837 16.1875 8.22222M19 11C19 11.778 16.7564 13.2316 16.1875 13.7778" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div v-show="!hided_menu">
                <span>Выйти</span>
              </div>
            </div>
          </div>

        </div>



      </div>
    </div>



    <div class="content">
      <header>
        <search-field type="catalog" :class="[{show_mobile_search: show_mobile_search}]" placeholder="Найти"></search-field>
        <svg @click="hideSearch()" class="hide_mobile_search" :class="[{show: show_mobile_search}]" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
          <path d="M16.5 5.58479L5.5 16.6213M16.5 16.6212L5.5 5.58472" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="left">
          <region-selector v-show="show_mobile_menu"></region-selector>
          <svg :class="[{hide: show_mobile_menu}]" class="show_mobile_menu" @click="showMobileMenu()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 5L20 5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 12L20 12" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 19L20 19" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <a href="/lk/main/"><img class="logo" :src="logoImg"></a>
        </div>
        <div class="right" :class="[{hide: show_mobile_menu}]">
          <svg
              @click="showSearch()"
              class="search-product-mobile-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M16.5 16.5L21 21" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10Z" stroke="#1B78BC" stroke-width="1.5" stroke-linejoin="round"/>
          </svg>
          <header-notification
              :hn_qnt="hn_qnt"
              :notification-data="notificationData"
              @notifications_changed="notifications_changed_handler()"
          >
          </header-notification>
          <header-basket :hb_qnt="hb_qnt"></header-basket>
          <header-personal ref="header_personal"></header-personal>
        </div>
        <svg @click="hideMobileMenu()" class="hide_mobile_menu" :class="[{show: show_mobile_menu}]" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
          <path d="M16.5 5.58479L5.5 16.6213M16.5 16.6212L5.5 5.58472" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </header>
      <main :class="[{hide: show_mobile_menu}]">
        <slot name="main"></slot>
      </main>
    </div>

    <div v-if="active_preloader" class="preloader">
      <div class="back"></div>
      <img class="loader" :src="images.preloader">
    </div>

  </div>
</template>

<script>
import HeaderNotification from '@/components/main_template/HeaderNotification.vue';
import HeaderBasket from '@/components/main_template/HeaderBasket.vue';
import HeaderPersonal from '@/components/main_template/HeaderPersonal.vue';
import MenuCompselector from '@/components/main_template/MenuCompselector.vue';
import axios from "axios";
import SearchField from "@/components/share/SearchField";
import RegionSelector from "@/components/main_template/RegionSelector";

export default {
  name: 'HomeView',
  data() {
    return{
      logoImg: require('@/assets/logo.png'),
      images: {
        dLogoImg: require('@/assets/logo.png'),
        mLogoImg: require('@/assets/m_logo.png'),
        preloader:  require('@/assets/preloader.gif')
      },

      hided_menu: false,
      show_mobile_menu: false,
      show_mobile_search: false,

      currRoute: this.$route.name,

      navItems: [
        {
          name: "Главная",
          route: "main",
          match_routes: ["main"],
          opened: false,
          subItems : [],
        },
        {
          name: "Каталог",
          route: "catalog",
          match_routes: ["catalog", "catalog_section", "catalog_product"],
          opened: false,
          subItems : [],
        },
        {
          name: "Мои заказы",
          route: "orders",
          match_routes: ["orders", "order_detail"],
          opened: false,
          subItems : [],
        },
        {
          name: "Взаиморасчёты",
          route: "mutual_settlements",
          match_routes: ["mutual_settlements",


          ],
          opened: false,
          subItems: [
            {
              name: "Расчеты",
              route: "calc",
              match_routes : ["calc"]
            },
            {
              name: "Документы",
              route: "documents",
              match_routes : ["documents"]
            },
          ]
        },
        {
          name: "Избранное",
          route: "favorite",
          match_routes: ["favorite"],
          opened: false,
          subItems : [],
        },
      ],
      hb_qnt: 0,
      basketData: null,

      hn_qnt: 0,
      notificationData: null,

      current_counterparty : {},

      from_login: false,

      show_region_selector_list: false,

      showPageContent: true,

      active_preloader: false,
    }
  },
  async mounted() {
    console.log(this.$route.name);

    if(this.$route.name == "privacy_policy" || this.$route.name == "offer") {
      this.showPageContent = false;
    }

    if(window.localStorage.getItem("main_template_hided_menu") == "true") {
      this.hided_menu = true;
      this.logoImg = this.images.mLogoImg;
    }
    else {
      this.hided_menu = false;
      this.logoImg = this.images.dLogoImg;
    }

    if(this.currRoute == "calc" || this.currRoute == "documents") {
      this.navItems[3].opened = true;
    }

    await this.refreshHeader();

    this.showPageContent = true;
  },
  components: {
    RegionSelector,
    SearchField,
    HeaderNotification,
    HeaderBasket,
    HeaderPersonal,
    MenuCompselector
  },
  methods : {
    navigate : function(routeName) {
      if(routeName == "main") {
        this.$router.push({ name: routeName, params: {tab: "main"} });
      }
      else {
        this.$router.push({ name: routeName });
      }

      this.currRoute = routeName;
    },
    toSettings : function(hash) {
      this.$router.push({ name: "main", params: {tab: "settings"}, hash: hash });
    },
    showSearch : function() {
      this.show_mobile_search = true;
    },
    hideSearch : function() {
      this.show_mobile_search = false;
    },
    logout: async function() {
      await axios.get(window.api_url + "auth/logout");
      this.$router.push({ name: "login"});
    },
    hideMenu : function () {
      if(!this.hided_menu)
      {
        this.hided_menu = true;
        this.logoImg = this.images.mLogoImg;

        localStorage.setItem("main_template_hided_menu", "true");
      }
      else
      {
        this.hided_menu = false;
        this.logoImg = this.images.dLogoImg;

        localStorage.setItem("main_template_hided_menu", "false");
      }
    },
    showMobileMenu : function() {
      this.show_mobile_menu = true;
    },
    hideMobileMenu : function() {
      this.show_mobile_menu = false;
    },
    openSelector : function() {
      this.$refs.header_personal.openSelector();
    },
    notifications_changed_handler: function() {
      this.refreshHeader();
    },
    toggle_region_selector: function() {
      this.show_region_selector_list = !this.show_region_selector_list;
    },
    refreshHeader : async function() {
      /*------------------------------------FROM-LOCAL-------------------------------------*/

      try {
        let local_res_json = localStorage.getItem("base_data");
        if(local_res_json != null) {
          let local_res_data = JSON.parse(local_res_json);

          this.hb_qnt = local_res_data.basket.total_quantity;

          this.$refs.header_personal.items = local_res_data.counterparties;
          this.$refs.header_personal.currentCounterparty = local_res_data.current_counterparty;

          this.current_counterparty = local_res_data.current_counterparty;

          this.hn_qnt = local_res_data.notifications.count;
          this.notificationData = local_res_data.notifications.list;
        }
      }
      catch(e) {
        console.log(e);
      }

      /*------------------------------------UPDATE-------------------------------------*/

      let res = await axios.get(window.api_url + "main/base");

      if(res.data.status == "error") {
        if(this.currRoute != "privacy_policy" && this.currRoute != "offer") {
          this.$router.push({name: "login"});
        }
        this.from_login = true;
        return;
      }
      localStorage.setItem("base_data", JSON.stringify(res.data.data));

      this.hb_qnt = res.data.data.basket.total_quantity;

      this.$refs.header_personal.items = res.data.data.counterparties;
      this.$refs.header_personal.currentCounterparty = res.data.data.current_counterparty;

      this.current_counterparty = res.data.data.current_counterparty;

      this.hn_qnt = res.data.data.notifications.count;
      this.notificationData = res.data.data.notifications.list;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.logo {
  display: flex;
}

.logo img {

}

.main-template {
  display: flex;
}

.main-template.from_login .menu{
  display: none;
}
.main-template.from_login header{
  display: none;
}
.main-template.from_login main{
  height: 100%;
}



.menu {
  height: calc(100vh - 28px);
  background: var(--White, #FFF);
  padding: 14px 20px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--Border, #EDEDED);
}

.menu.hided {
  width: unset;
  max-width: unset;
  min-width: unset;
}

.menu .header {
  padding-bottom: 13px;
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.menu .header.hided {
  justify-content: center;
}

.menu .header .hide_menu {
  padding: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.menu .header .hide_menu.active {
  border: 1px solid var(--Border, #EDEDED);
  border-radius: 100px;
  transform: rotate(180deg);
  position: absolute;
  left: 50px;
  z-index: 10;
  background: #fff;
}

.menu .navigations {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.menu .navigation {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.menu .navigation.bottom{

}

.menu .navigation .nav_item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.menu .navigation .nav_item .top_level_item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 11px 12px;
  border-radius: 8px;
}

.menu .navigation .nav_item .top_level_item:hover {
  background: var(--BG, #F8F8F8);
}

.menu .navigation .nav_item.active .top_level_item {
  background: rgba(27, 120, 188, 0.10);
}

.menu .navigation .nav_item.active .top_level_item span {
  color: #1B78BC;
}

.menu .navigation .nav_item .top_level_item div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex: 1;
}

.open_sub_menu.open {
  transform: rotate(180deg);
}

.menu .navigation .nav_item .sub_level {
  padding-left: 11px;
  margin-left: 22px;
  display: none;
  flex-direction: column;
  gap: 2px;
  border-left: 1px solid #EDEDED;
}

.menu .navigation .nav_item .sub_level.open {
  display: flex;
}

.menu .navigation .nav_item .sub_level span {
  color: var(--Gray, #656565);
  margin: 11px 14px;
  font-size: 14px;
  cursor: pointer;
}

.menu .navigation .nav_item .sub_level span.active {
  color: #1B78BC;
}

.menu .navigation .nav_item svg {
  width: 24px;
  height: 24px;
}

.menu .navigation .nav_item span {
  color: #1B78BC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.menu .navigation .nav_item.active svg path{
  stroke: #1B78BC;
}

.menu .navigation .nav_item span{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}


.content {
  flex: 1;
  height: 100vh;
  width: calc(100% - 291px);
}



header {
  padding: 10px 32px;
  border-bottom: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  height: 43px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

header .left {
  visibility: hidden;
  display: none;
}

header .right{
  display: flex;
  align-items: center;
  gap: 30px;
}

header .search-product {
  margin: 0px;
  width: 500px;
}

.search-product-mobile-btn {
  display: none;
}


main {
  background: var(--BG, #F8F8F8);
  height: calc(100vh - 128px);
  padding: 32px;
  overflow: auto;
}

.preloader {
  height: 100%;
  width: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 100;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.preloader .back {
  height: 100%;
  width: 100%;
  position: fixed;
}

.loader {
  width: 100px;
  height: 100px;
  background: transparent;
}



/*MOBILE*/
.hide_mobile_menu {
  display: none;
}

.hide_mobile_menu.show {
  display: block;
}

header .hide_mobile_search {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .main-template.from_login main{
    margin-top: 0px;
  }

  .menu {
    display: none;
    position: absolute;
    width: calc(100% - 30px);
    top: 74px;
    padding: 15px;
    height: calc(100% - 104px);
    z-index: 10;
    border-right: unset;
  }

  .menu.mobile_show {
    display: flex;
  }

  .menu .header {
    display: none;
  }

  .content {
    width: 100%;
  }

  header {
    padding: 15px;
    position: fixed;
    z-index: 15;
    width: calc(100% - 30px);
  }

  header .left {
    visibility: visible;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .show_mobile_menu.hide {
    display: none;
  }

  header .show_mobile_menu {
    cursor: pointer;
  }

  header .right {
    gap: 15px;
  }

  header .search-product {
    display: none;
    width: calc(100% - 30px);
  }

  header .search-product.show_mobile_search {
    display: block;
    position: fixed;
    z-index: 100;
  }

  header .hide_mobile_search {
    display: none;
  }

  header .hide_mobile_search.show {
    display: block;
    z-index: 100;
    position: absolute;
    left: 20px;
  }

  .search-product-mobile-btn {
    display: block;
    cursor: pointer;
  }

  main {
    padding: 20px 15px;
    height: auto;
    min-height: calc(100% - 114px);
    overflow: unset;
    margin-top: 74px;
  }

  main.hide {
    display: none;
  }

}

</style>

<style>
.page_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.main-template.from_login .page_top .breadcrumbs{
  display: none !important;
}

.page_top .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin: 0px;
  display: flex;
  gap: 8px;
}

.page_top .title .title_span {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

header .right.hide .header-personal .image {
  display: none;
}

header .right.hide .header-notification {
  display: none;
}

header .right.hide .search-product-mobile-btn {
  display: none;
}

header .right.hide .header-basket {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .page_top {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
  }
}
</style>